import React, { useEffect, useRef } from 'react';

import { window } from '../src/env/browser';
import { useGlobals } from '@shared/contexts/GlobalsContext';

import useCreateAppConfig from './use-create-app-config';
import {
  containerStyle,
  iframeStyle,
  MICRO_APP_STARTUP_MESSAGE,
  MICRO_APP_URL,
} from './constants';

const APP_NAME = 'appointment-v4';

export function AppointmentV4App() {
  const deps = useGlobals();
  const iframeRef = useRef(null);
  const { isLoading, config } = useCreateAppConfig(APP_NAME, deps);

  useEffect(() => {
    if (iframeRef.current && !isLoading) {
      setTimeout(() => {
        window.Shore.microAppArgs[APP_NAME] = {
          ...config,

          // Dev harness: The app shell mounts this micro-app at `/appointment-v4` and uses hash URLs
          // like `#/appointment-v4/course/<id>`. `HashRouter` must use the same
          // `basename` so it strips the `/appointment-v4` prefix before route matching.
          // The playground mounts at `/`, which leaves `/appointment-v4/...` in the hash
          // and causes route matching to fail. Defaulting a root or missing `mountPath`
          // to `/appointment-v4` keeps dev environment working.
          mountPath:
            config?.mountPath && config.mountPath !== '/'
              ? config.mountPath
              : `/${APP_NAME}`,
        };
        iframeRef.current.contentWindow.postMessage(
          { type: MICRO_APP_STARTUP_MESSAGE },
          '*'
        );
      }, 1000);
    }
  }, [iframeRef.current, isLoading]);

  return (
    <div style={containerStyle}>
      <iframe
        id="micro-appointment-v4-app"
        title="AppointmentV4App"
        ref={iframeRef}
        style={iframeStyle}
        // TODO: Update the URL and add a date time
        src={`${MICRO_APP_URL}/appointment-v4/#/appointment-v4/course/806d1111-d524-4c44-933d-28150e1225fc`}
      />
    </div>
  );
}
